import Img3dHammerRaw from './3dHammer.png.js';
export { default as IconAccount } from './Account.svg.js';
export { default as IconAirbnb } from './Airbnb.svg.js';
export { default as IconAlert } from './Alert.svg.js';
export { default as IconAmazon } from './Amazon.svg.js';
export { default as IconAndroid } from './Android.svg.js';
export { default as IconApple } from './Apple.svg.js';
export { default as IconAppleConnection } from './AppleConnection.svg.js';
export { default as IconApps } from './Apps.svg.js';
export { default as IconArrowRight } from './ArrowRight.svg.js';
export { default as IconAsos } from './Asos.svg.js';
export { default as IconAssistantTab } from './AssistantTab.svg.js';
export { default as IconBack } from './Back.svg.js';
export { default as IconBackArrow } from './BackArrow.svg.js';
export { default as IconBell } from './Bell.svg.js';
export { default as IconBin } from './Bin.svg.js';
export { default as IconBookmarkFlag } from './BookmarkFlag.svg.js';
export { default as IconBrainstorm } from './Brainstorm.svg.js';
export { default as IconBuzzNoteImage } from './BuzzNoteImage.svg.js';
export { default as IconBuzzNotePage } from './BuzzNotePage.svg.js';
export { default as IconBuzzNoteText } from './BuzzNoteText.svg.js';
export { default as IconCamera } from './Camera.svg.js';
export { default as IconCameraOff } from './CameraOff.svg.js';
export { default as IconCameraPlus } from './CameraPlus.svg.js';
import ImgCaptureRaw from './Capture.png.js';
import ImgCaptureLinkRaw from './CaptureLink.png.js';
export { default as IconCelebration } from './Celebration.svg.js';
export { default as IconCheck } from './Check.svg.js';
export { default as IconCheckRounded } from './CheckRounded.svg.js';
export { default as IconCheckmark } from './Checkmark.svg.js';
export { default as IconChevronDown } from './ChevronDown.svg.js';
export { default as IconChevronDownFill } from './ChevronDownFill.svg.js';
export { default as IconChevronLeft } from './ChevronLeft.svg.js';
export { default as IconChevronRight } from './ChevronRight.svg.js';
export { default as IconChevronRightThin } from './ChevronRightThin.svg.js';
export { default as IconCloudTick } from './CloudTick.svg.js';
export { default as IconCollectionExpand } from './CollectionExpand.svg.js';
export { default as IconComment } from './Comment.svg.js';
export { default as IconComments } from './Comments.svg.js';
export { default as IconConnection } from './Connection.svg.js';
export { default as IconConversation } from './Conversation.svg.js';
export { default as IconConversationMobile } from './ConversationMobile.svg.js';
export { default as IconCreate } from './Create.svg.js';
export { default as IconDocument } from './Document.svg.js';
export { default as IconDotMenu } from './DotMenu.svg.js';
export { default as IconDragAndDropIcon } from './DragAndDropIcon.svg.js';
export { default as IconDribble } from './Dribble.svg.js';
export { default as IconDropbox } from './Dropbox.svg.js';
export { default as IconEmptyCactus } from './EmptyCactus.svg.js';
export { default as IconEmptyChat } from './EmptyChat.svg.js';
export { default as IconEmptyContent } from './EmptyContent.svg.js';
export { default as IconEmptyHistory } from './EmptyHistory.svg.js';
import ImgEmptySearchRaw from './EmptySearch.png.js';
export { default as IconEmptyTabs } from './EmptyTabs.svg.js';
export { default as IconEmptyTabsDark } from './EmptyTabsDark.svg.js';
export { default as IconEnter } from './Enter.svg.js';
export { default as IconEphemeralPen } from './EphemeralPen.svg.js';
export { default as IconExpand } from './Expand.svg.js';
export { default as IconFabric } from './Fabric.svg.js';
import ImgFabricAppRaw from './FabricApp.png.js';
import ImgFabricAppSmallRaw from './FabricAppSmall.png.js';
export { default as IconFaceMode } from './FaceMode.svg.js';
export { default as IconFancyCursor } from './FancyCursor.svg.js';
export { default as IconFigma } from './Figma.svg.js';
export { default as IconFilledArrowDown } from './FilledArrowDown.svg.js';
export { default as IconFilter } from './Filter.svg.js';
import ImgFolderRaw from './Folder.png.js';
import ImgFolderDeviceRaw from './FolderDevice.png.js';
export { default as IconForwardArrow } from './ForwardArrow.svg.js';
export { default as IconGesturePan } from './GesturePan.svg.js';
export { default as IconGesturePinch } from './GesturePinch.svg.js';
export { default as IconGithub } from './Github.svg.js';
export { default as IconGoogle } from './Google.svg.js';
export { default as IconGoogleDrive } from './GoogleDrive.svg.js';
export { default as IconGoogleLogo } from './GoogleLogo.svg.js';
export { default as IconGrid } from './Grid.svg.js';
export { default as IconHeadphones } from './Headphones.svg.js';
export { default as IconHeadphonesCrossed } from './HeadphonesCrossed.svg.js';
export { default as IconHeart } from './Heart.svg.js';
export { default as IconHistory } from './History.svg.js';
export { default as IconInfoTabItem } from './InfoTabItem.svg.js';
export { default as IconInputEye } from './InputEye.svg.js';
export { default as IconInputEyeCrossed } from './InputEyeCrossed.svg.js';
export { default as IconInvertedFabric } from './InvertedFabric.svg.js';
export { default as IconInvite } from './Invite.svg.js';
export { default as IconKeyboard } from './Keyboard.svg.js';
export { default as IconLeave } from './Leave.svg.js';
export { default as IconLinear } from './Linear.svg.js';
export { default as IconLink } from './Link.svg.js';
export { default as IconLinkExternal } from './LinkExternal.svg.js';
export { default as IconList } from './List.svg.js';
export { default as IconLock } from './Lock.svg.js';
export { default as IconLogo } from './Logo.svg.js';
export { default as IconLogout } from './Logout.svg.js';
export { default as IconMeltingFaceEmoji } from './MeltingFaceEmoji.svg.js';
export { default as IconMessage } from './Message.svg.js';
export { default as IconMicrophone } from './Microphone.svg.js';
export { default as IconMicrophoneCrossed } from './MicrophoneCrossed.svg.js';
export { default as IconNewNote } from './NewNote.svg.js';
export { default as IconNewTag } from './NewTag.svg.js';
export { default as IconNotion } from './Notion.svg.js';
export { default as IconOldBookmark } from './OldBookmark.svg.js';
export { default as IconOldCopy } from './OldCopy.svg.js';
export { default as IconOldDownload } from './OldDownload.svg.js';
export { default as IconOldPadlock } from './OldPadlock.svg.js';
export { default as IconOldPencil } from './OldPencil.svg.js';
export { default as IconOldPlus } from './OldPlus.svg.js';
export { default as IconOnedrive } from './Onedrive.svg.js';
export { default as IconOpenBook } from './OpenBook.svg.js';
export { default as IconOpenExternal } from './OpenExternal.svg.js';
export { default as IconPenDrawing } from './PenDrawing.svg.js';
export { default as IconPlan } from './Plan.svg.js';
export { default as IconPlug } from './Plug.svg.js';
export { default as IconPrint } from './Print.svg.js';
export { default as IconPrivateEye } from './PrivateEye.svg.js';
export { default as IconQuickCapture } from './QuickCapture.svg.js';
export { default as IconReadwise } from './Readwise.svg.js';
export { default as IconReload } from './Reload.svg.js';
export { default as IconReply } from './Reply.svg.js';
export { default as IconResearch } from './Research.svg.js';
export { default as IconRightArrow } from './RightArrow.svg.js';
export { default as IconRoundedBookmark } from './RoundedBookmark.svg.js';
export { default as IconRoundedChevronRight } from './RoundedChevronRight.svg.js';
export { default as IconScreenshare } from './Screenshare.svg.js';
export { default as IconScreenshareFull } from './ScreenshareFull.svg.js';
export { default as IconScreenshareTab } from './ScreenshareTab.svg.js';
export { default as IconScreenshareWindow } from './ScreenshareWindow.svg.js';
export { default as IconScreenshotRegion } from './ScreenshotRegion.svg.js';
export { default as IconSession } from './Session.svg.js';
export { default as IconSessionGlobe } from './SessionGlobe.svg.js';
export { default as IconSessionInverted } from './SessionInverted.svg.js';
export { default as IconShare } from './Share.svg.js';
export { default as IconSharePlusIOS } from './SharePlusIOS.svg.js';
export { default as IconShock } from './Shock.svg.js';
export { default as IconShockCrossed } from './ShockCrossed.svg.js';
export { default as IconShopify } from './Shopify.svg.js';
export { default as IconShutdown } from './Shutdown.svg.js';
export { default as IconSidebar } from './Sidebar.svg.js';
export { default as IconSidebarOpen } from './SidebarOpen.svg.js';
export { default as IconSimpleFabric } from './SimpleFabric.svg.js';
export { default as IconSkyscanner } from './Skyscanner.svg.js';
export { default as IconSortAsc } from './SortAsc.svg.js';
export { default as IconSortDesc } from './SortDesc.svg.js';
export { default as IconSound } from './Sound.svg.js';
export { default as IconSpacesHome } from './SpacesHome.svg.js';
export { default as IconStar } from './Star.svg.js';
export { default as IconSuggestionArrowsDesktop } from './SuggestionArrowsDesktop.svg.js';
export { default as IconSuggestionArrowsMobile } from './SuggestionArrowsMobile.svg.js';
export { default as IconTags } from './Tags.svg.js';
export { default as IconTimeline } from './Timeline.svg.js';
export { default as IconTrello } from './Trello.svg.js';
export { default as IconUpdate } from './Update.svg.js';
export { default as IconUpload } from './Upload.svg.js';
export { default as IconUploadArrow } from './UploadArrow.svg.js';
export { default as IconUpsellCross } from './UpsellCross.svg.js';
export { default as IconUpsellTick } from './UpsellTick.svg.js';
export { default as IconUrl } from './Url.svg.js';
export { default as IconVideo } from './Video.svg.js';
export { default as IconWeb } from './Web.svg.js';
export { default as IconWorld } from './World.svg.js';
export { default as IconYoutube } from './Youtube.svg.js';
export { default as IconZapier } from './Zapier.svg.js';
export { default as IconBrave } from './brave.svg.js';
export { default as IconChrome } from './chrome.svg.js';
export { default as IconEdge } from './edge.svg.js';
export { default as IconEmptyState } from './emptyState.svg.js';
export { default as IconNewSpaceIcon } from './new-space-icon.svg.js';
export { default as IconAll } from './categories/All.svg.js';
export { default as IconFile } from './categories/File.svg.js';
export { default as IconImage } from './categories/Image.svg.js';
export { default as IconNote } from './categories/Note.svg.js';
export { default as IconPage } from './categories/Page.svg.js';
export { default as IconText } from './categories/Text.svg.js';
export { default as IconArrow1 } from './onboarding/Arrow1.svg.js';
export { default as IconArrow2 } from './onboarding/Arrow2.svg.js';
export { default as IconArrow3 } from './onboarding/Arrow3.svg.js';
export { default as IconArrow4 } from './onboarding/Arrow4.svg.js';
export { default as IconArrow5 } from './onboarding/Arrow5.svg.js';
export { default as IconArrow6 } from './onboarding/Arrow6.svg.js';
export { default as IconArrow7 } from './onboarding/Arrow7.svg.js';
export { default as IconArrow8 } from './onboarding/Arrow8.svg.js';
export { default as IconArrow9 } from './onboarding/Arrow9.svg.js';
export { default as IconCrash } from './pc/crash.svg.js';
export { default as IconDuplicate } from './pc/duplicate.svg.js';
export { default as IconSleeping } from './pc/sleeping.svg.js';
export { default as IconSlow } from './pc/slow.svg.js';
export { default as IconSurprised } from './pc/surprised.svg.js';

const Img3dHammer = Img3dHammerRaw ;
const ImgCapture = ImgCaptureRaw ;
const ImgCaptureLink = ImgCaptureLinkRaw ;
const ImgEmptySearch = ImgEmptySearchRaw ;
const ImgFabricApp = ImgFabricAppRaw ;
const ImgFabricAppSmall = ImgFabricAppSmallRaw ;
const ImgFolder = ImgFolderRaw ;
const ImgFolderDevice = ImgFolderDeviceRaw ;

export { Img3dHammer, ImgCapture, ImgCaptureLink, ImgEmptySearch, ImgFabricApp, ImgFabricAppSmall, ImgFolder, ImgFolderDevice };
//# sourceMappingURL=index.js.map
